/**
 * Shared date / id formatting helpers for the admin SPA.
 *
 * Extracted from five drifted `fmtDate` copies, an `fmtIso` copy, and three
 * `truncateId` variants (deep-code-analysis §3). Kept dependency-light — this
 * module must NOT import `@/lib/hub-client` (directly or transitively) so the
 * no-jsdom unit tests can import it without booting a HubClient.
 */

/** Date-only (`YYYY-MM-DD`). Nullish → em-dash. */
export function fmtDate(value: string | null | undefined): string {
  return !value ? '—' : new Date(value).toISOString().slice(0, 10);
}

/** Date + time to the minute (`YYYY-MM-DD HH:MM`). Nullish → em-dash. */
export function fmtDateTime(value: string | null | undefined): string {
  return !value ? '—' : new Date(value).toISOString().slice(0, 16).replace('T', ' ');
}

/** Full ISO-8601 timestamp. Nullish → em-dash. */
export function fmtIso(value: string | null | undefined): string {
  return !value ? '—' : new Date(value).toISOString();
}

/**
 * Head…tail id abbreviation (canonical, moved verbatim from
 * `schedules/schedule-ui-model.ts`). Values short enough to show in full
 * (≤ head + tail + 1) render unchanged; nullish → em-dash.
 */
export function truncateId(value: string | null | undefined, head = 8, tail = 4): string {
  if (!value) return '—';
  if (value.length <= head + tail + 1) return value;
  return `${value.slice(0, head)}…${value.slice(-tail)}`;
}
